/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Email_Settings_SidebarInputs */

const en_admin_email_settings_sidebar = /** @type {(inputs: Admin_Email_Settings_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Settings`)
};

const de_admin_email_settings_sidebar = /** @type {(inputs: Admin_Email_Settings_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail Einstellungen`)
};

/**
* | output |
* | --- |
* | "Email Settings" |
*
* @param {Admin_Email_Settings_SidebarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_email_settings_sidebar = /** @type {((inputs?: Admin_Email_Settings_SidebarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Email_Settings_SidebarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_email_settings_sidebar(inputs)
	return en_admin_email_settings_sidebar(inputs)
});